<app-context-menu [options]="{ width: '240px', noSpacing: true }" #menu>
  <button appButton name="share" location="article-share" shape="round" weight="bold" contextButton>
    <app-svg src="/assets/icons/move-out.svg"></app-svg>
    <span>Share</span>
  </button>
  <div contextContent>
    <app-share-menu
      [title]="story().content.title"
      [text]="story().content.title"
      [link]="shareLink()"
      (onClose)="menu.close()"
    >
    </app-share-menu>
  </div>
</app-context-menu>
